import { PlanType } from '../../types/planType'
import { PlanTypeVariableKey } from '../../types/PlanTypeVariableKey'

export function convertPlanTypeToFeatureFlagKey(planType: PlanType): PlanTypeVariableKey {
  switch (planType) {
    case PlanType.ENTERPRISE:
      return 'ENTERPRISE'
    case PlanType.FREE:
      return 'FREE'
    case PlanType.PRO:
      return 'PRO'
    case PlanType.PRO_FLEX:
      return 'PRO_FLEX'
    case PlanType.PRO_PLUS_ORG:
      return 'PRO_PLUS'
    default:
      return 'PRO_PLUS'
  }
}
